import SKUTableController from '../../../../../../components/domain/SKUTable/SKUTableController';
import React from 'react';
import { Section } from '@ydistri/ds';
import { NO_VALUE } from '../../../../../../lib/utils/utilsTypes';

interface SKUTableSectionProps {
  productId?: number;
  storeId?: number;
}

const SKUTableSection: React.FC<SKUTableSectionProps> = ({
  productId = NO_VALUE,
  storeId = NO_VALUE,
}) => {
  if (productId === NO_VALUE && storeId === NO_VALUE) {
    return null;
  }

  return (
    <Section header="Product / Store combinations">
      <SKUTableController productId={productId} storeId={storeId} />
    </Section>
  );
};

export default SKUTableSection;
